import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { HwtButton } from '../Buttons/HwtButton';
import { translate } from 'translations/translator';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import ModalsTranslationVariant from 'translations/variants/modals';
import { ModalPadding } from 'styles/style-constants';
type Props = {
  teachingOrderTitle: string | undefined;
  teachingOrderDocumentation?: string | undefined;
  handleUseTeachingOrder: () => void;
};

const getTranslation = (key: ModalsTranslationVariant) => translate('modals', key);
export const TeachingOrderConfirmationModal: React.FC<Props> = ({
  teachingOrderTitle,
  teachingOrderDocumentation,
  handleUseTeachingOrder
}) => {
  const classes = useStyles();
  const [, { closeModal }] = useModal();
  const withCloseModal = cb => () => {
    cb();
    closeModal();
  };
  return (
    <Container className={classes.container}>
      <Typography className={classes.title} variant="h6">
        {getTranslation(ModalsTranslationVariant.teachingOrderAreYouSure)}
      </Typography>
      <Box display="flex" flexDirection="column" className={classes.boxContainer}>
        <Typography variant="body2" style={{ padding: 16 }}>
          {teachingOrderTitle}
        </Typography>
        <Typography variant="body2" style={{ padding: '0 16px', fontWeight: 300 }}>
          {teachingOrderDocumentation && (
            <a href={teachingOrderDocumentation} target="_blank" rel="noopener noreferrer">
              {getTranslation(ModalsTranslationVariant.clickHere)}
            </a>
          )}
        </Typography>
      </Box>
      <Box display="flex">
        <Typography variant="body2" style={{ fontWeight: 300, padding: '12px 9px 0px 9px' }}>
          {getTranslation(ModalsTranslationVariant.teachingOrderDetails)}
        </Typography>
      </Box>
      <Box display="flex" className={classes.btnActionGroup}>
        <HwtButton onClick={closeModal} className={classes.button} variant="outlined">
          {getTranslation(ModalsTranslationVariant.teachingOrderBackToManage)}
        </HwtButton>
        <HwtButton
          onClick={withCloseModal(handleUseTeachingOrder)}
          className={classes.button}
          variant="contained"
        >
          {getTranslation(ModalsTranslationVariant.teachingOrderUseTeachingOrder)}
        </HwtButton>
      </Box>
    </Container>
  );
};

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: 'flex !important',
    justifyContent: 'space-evenly',
    flex: 1,
    flexDirection: 'column',
    overflow: 'hidden',
    ...ModalPadding,
    height: '387px',
    width: '616px',
    backgroundColor: '#fff'
  },
  button: {
    width: 'max-content !important'
  },
  boxContainer: () => ({
    width: '568px',
    backgroundColor: theme.palette.grey.lightest
  }),
  title: {
    display: 'flex',
    flex: '.05',
    padding: '18px 6px',
    alignSelf: 'center'
  },
  btnActionGroup: {
    marginTop: '24px',
    justifyContent: 'space-between'
  }
}));

export const useTeachingOrderStyles = useStyles;
